<nav class="navbar navbar-expand-lg navbar-dark bg-gradient">
  <div class="container-fluid">
    <!-- Logo -->
    <a class="navbar-brand d-flex align-items-center" href="#">
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" class="bi bi-upc-scan me-2"
        viewBox="0 0 16 16">
        <path
          d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5M.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5M3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0z" />
      </svg>
      <strong>SafeScan</strong>
    </a>

    <!-- Toggle Button -->
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Menu Items -->
    <div class="collapse navbar-collapse" id="navbarNav" *ngIf="isLoggedIn">     
      <ul class="navbar-nav ms-auto">
        <li class="nav-item" *ngIf="userRole === 'StoreAdmin' || userRole === 'StoreUser'">
          <span class="nav-link text-light px-3" tabindex="-1" aria-disabled="true">
            {{ storeName }}
          </span></li>
        <li class="nav-item">
          <button class="nav-link active text-light px-3" (click)="logout()">Logout</button>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle text-light px-3" href="#" role="button" data-bs-toggle="dropdown">
            Actions
          </a>
          <ul class="dropdown-menu dropdown-menu-dark dropdown-menu-end">
            <li><a class="dropdown-item" *ngIf="userRole === 'Admin'" routerLink="/store">Manage Store</a></li>
            <li><a class="dropdown-item" *ngIf="userRole === 'StoreAdmin'" routerLink="/user">Manage User</a></li>
            <li><hr class="dropdown-divider"></li>
            <li><a class="dropdown-item" routerLink="/batchlist">Manage Batch</a></li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="collapse navbar-collapse" id="navbarNav" *ngIf="!isLoggedIn">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item">
          <a class="nav-link active text-light px-3" routerLink="/login" *ngIf="showLoginButton">Login</a>
        </li>
      </ul>
    </div>
  </div>
</nav>